import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Invoices from './pages/Invoices';
import InvoiceDetails from './pages/InvoiceDetails';
import Companies from './pages/Companies';
import Vendors from './pages/Vendors';
import VendorOnboarding from './pages/VendorOnboarding';
import ImportVendor from './components/ImportVendor';
import Estimates from './pages/Estimates';
import Bills from './pages/Bills';
import TimeEntries from './pages/TimeEntries';
import Settings from './pages/Settings';
import WorkflowManagement from './pages/WorkflowManagement';
import ComplianceReports from './pages/ComplianceReports';
import UserManagement from './pages/UserManagement';
import Departments from './pages/Departments';
import Reports from './pages/Reports';
import Currencies from './pages/Currencies';
import FinancialPowerProposal from './pages/FinancialPowerProposal';
import FinancialPowerProposalDetails from './pages/FinancialPowerProposalDetails';
import FinancialPowerInvoice from './pages/FinancialPowerInvoice';
import CreateFinancialPowerInvoice from './pages/CreateFinancialPowerInvoice';

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-gray-50">
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#10B981',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#EF4444',
                secondary: '#fff',
              },
            },
          }}
        />
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forget-password/*" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          
          {/* Protected routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="invoices/:id" element={<InvoiceDetails />} />
            <Route path="companies" element={<Companies />} />
            <Route path="vendors" element={<Vendors />} />
            <Route path="vendors/import" element={<ImportVendor />} />
            <Route path="vendors/:vendorId/onboarding" element={<VendorOnboarding />} />
            <Route path="estimates" element={<Estimates />} />
            <Route path="bills" element={<Bills />} />
            <Route path="time-entries" element={<TimeEntries />} />
            <Route path="workflows" element={<WorkflowManagement />} />
            <Route path="departments" element={<Departments />} />
            <Route path="currencies" element={<Currencies />} />
            <Route path="financial-power-proposal" element={<FinancialPowerProposal />} />
            <Route path="financial-power-proposal/:id" element={<FinancialPowerProposalDetails />} />
            <Route path="financial-power-invoice" element={<FinancialPowerInvoice />} />
            <Route path="financial-power-invoice/create" element={<CreateFinancialPowerInvoice />} />
            <Route path="compliance-reports" element={<ComplianceReports />} />
            <Route path="user-management" element={<UserManagement />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App; 